"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FILE_COUNT_OPTIONS = exports.FILE_SIZE_OPTIONS = exports.FILE_TYPES = exports.FieldType = exports.toShowFields = void 0;
exports.toShowFields = {
    "text-field": {
        label: true,
        placeholder: true,
        charLimit: true,
        mandatory: true,
        validation: true,
    },
    date: {
        label: true,
        placeholder: true,
        mandatory: true,
        validation: true,
    },
    "drop-down": {
        label: true,
        options: true,
        mandatory: true,
        validation: true,
    },
    "multi-select": {
        label: true,
        options: true,
        mandatory: true,
        validation: true,
    },
    time: {
        label: true,
        placeholder: true,
        mandatory: true,
        validation: true,
    },
    textarea: {
        label: true,
        placeholder: true,
        charLimit: true,
        mandatory: true,
        validation: true,
    },
    Phone: {
        label: true,
        options: true,
        mandatory: true,
        validation: true,
    },
    email: {
        label: true,
        placeholder: true,
        mandatory: true,
        validation: true,
        charLimit: true,
    },
    checkboxes: {
        label: true,
        options: true,
        mandatory: true,
        validation: true,
    },
    DocumentType: {
        label: true,
        placeholder: true,
        filetype: true,
        mandatory: true,
        validation: true,
    },
};
exports.FieldType = [
    "text-field",
    "date",
    "drop-down",
    "time",
    "Phone",
    "textarea",
    "email",
    "checkboxes",
    "DocumentType",
];
exports.FILE_TYPES = [
    "Document",
    "Spreadsheet",
    "PDF",
    "Video",
    "Presentation",
    "Drawing",
    "Image",
    "Audio",
];
exports.FILE_SIZE_OPTIONS = ["1 MB", "5 MB", "10 MB", "20 MB", "50 MB"];
exports.FILE_COUNT_OPTIONS = [1, 2, 5, 10, 20];
